import React, { useState, useEffect } from 'react';
import { Modal, Button, Table } from 'antd';

// Helper to format timestamp to MM/DD/YY HH:mm
const formatDate = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(Number(timestamp));
  if (isNaN(date.getTime())) return '';
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yy = String(date.getFullYear()).slice(-2);
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${mm}/${dd}/${yy} ${hh}:${min}`;
};

// Helper to format ISO timestamp to MM/DD/YY HH:mm
const formatIsoDate = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '';
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yy = String(date.getFullYear()).slice(-2);
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${mm}/${dd}/${yy} ${hh}:${min}`;
};

const columns = [
  {
    title: 'Batch ID',
    dataIndex: 'batchId',
    key: 'batchId',
    align: 'center',
    render: (text) => <span>{text}</span>,
  },
  {
    title: 'Branch',
    dataIndex: 'user',
    key: 'user',
    align: 'center',
    render: (text) => <span>{text}</span>,
  },
  {
    title: 'Created By User',
    dataIndex: 'createdBy',
    key: 'createdBy',
    align: 'center',
    render: (text) => <span>{text || '-'}</span>,
  },
  {
    title: 'Created Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    align: 'center',
    render: (val) => <span>{formatDate(val)}</span>,
  },
  {
    title: 'Updated By User(CT)',
    dataIndex: 'updatedBy',
    key: 'updatedBy',
    align: 'center',
    render: (text) => <span>{text || '-'}</span>,
  },
  {
    title: 'Updated Date(CT)',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    align: 'center',
    render: (val) => <span>{formatIsoDate(val)}</span>,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: (text) => <span>{text || '-'}</span>,
  },
];

const headerStyle = {
  background: '#EAEEFF',
  fontWeight: 600,
};

const BatchSelectModal = ({
  visible,
  onClose,
  batches = [],
  onSelectBatch,
  selectedBatchId,
}) => {
  const [selectedRowKey, setSelectedRowKey] = useState(selectedBatchId || '');

  useEffect(() => {
    setSelectedRowKey(selectedBatchId || '');
  }, [selectedBatchId, visible]);

  // Prepare data for the table
  const dataSource = (batches || []).map((b, idx) => ({
    key: b.batchId,
    batchId: b.batchId,
    user: b.user,
    createdBy: b.createdBy,
    createdAt: b.createdAt,
    updatedBy: b.updatedBy,
    updatedAt: b.updatedAt || b.createdAt,
    status: b.status,
    })
  );

  const rowSelection = {
    type: 'radio',
    selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
    onChange: (selectedKeys) => {
      setSelectedRowKey(selectedKeys[0]);
    },
  };

  const handleSubmit = () => {
    if (selectedRowKey) {
      onSelectBatch(selectedRowKey);
      onClose();
    }
  };

  return (
    <Modal
      title={<span style={{ fontWeight: 600 }}>Time Entry - Select Batch</span>}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="submit" type="primary" onClick={handleSubmit} disabled={!selectedRowKey}>
          Submit
        </Button>,
      ]}
      width={1000}
    >
      <Table
        dataSource={dataSource}
        columns={columns.map(col => ({
          ...col,
          onHeaderCell: () => ({
            style: headerStyle,
          }),
        }))}
        rowSelection={rowSelection}
        pagination={false}
        scroll={{ y: 400 }}
        bordered
      />
    </Modal>
  );
};

export default BatchSelectModal;